import React from "react";

import loadable from "@loadable/component";

import LoadingIndicator from "../../../LoadingIndicator";

const components = {
    Adblue: loadable(() => import("./Adblue")),
    Ausbildung: loadable(() => import("./Ausbildung")),
    FluessiggasZaehlerstand: loadable(() =>
        import("./FluessiggasZaehlerstand")
    ),
    Flüssiggas: loadable(() => import("./Flüssiggas")),
    Gaszähler: loadable(() => import("./Gaszähler")),
    Gewerbegas: loadable(() => import("./Gewerbegas")),
    Gewerbestrom: loadable(() => import("./Gewerbestrom")),
    Grillgas: loadable(() => import("./Grillgas")),
    Holzpellets: loadable(() => import("./Holzpellets")),
    HoyerCard: loadable(() => import("./HoyerCard")),
    Karriere: loadable(() => import("./Karriere")),
    Oilfox: loadable(() => import("./Oilfox")),
    MA: loadable(() => import("./MA")),
    ServiceCenter: loadable(() => import("./ServiceCenter")),
    Stromzähler: loadable(() => import("./Stromzähler")),
    Studium: loadable(() => import("./Studium")),
    Tanktechnik: loadable(() => import("./Tanktechnik")),
    FutureFuels: loadable(() => import("./FutureFuels")),
    Baustellenversorgung: loadable(() => import("./Baustellenversorgung")),
    Diesel: loadable(() => import("./Diesel")),
    Standortentwicklung: loadable(() => import("./Standortentwicklung")),
    PelletsWaermekonto: loadable(() => import("./PelletsWaermekonto")),
    Marine: loadable(() => import("./Marine")),
    Thg: loadable(() => import("./Thg")),
    FluessiggasZipcode: loadable(() => import("./FluessiggasZipcode")),
    HVO100: loadable(() => import("./HVO100")),
    ShopArtikel: loadable(() => import("./ShopArtikel")),
    MarineTrading: loadable(() => import("./MarineTrading")),
    TradingAndSupply: loadable(() => import("./TradingAndSupply")),
    HeizoelZipcode: loadable(() => import("./HeizölZipcode")),
    PowerTrust: loadable(() => import("./PowerTrust")),
    Schmierstoffe: loadable(() => import("./Schmierstoffe")),
};

const ContactForm = ({
    contactFormName,
    useFormalAddress,
    lang = "de",
    name,
}) => {
    const Component = components[contactFormName];

    return Component ? (
        <Component
            useFormalAddress={useFormalAddress}
            lang={lang}
            name={name}
            fallback={
                <LoadingIndicator>Daten werden geladen…</LoadingIndicator>
            }
        />
    ) : null;
};
export default ContactForm;
